import _extends from "@babel/runtime/helpers/esm/extends";
import { ELanguage } from '../common';
import { fieldsIBaseModel } from './base';
import { ELumaBotFlowType } from './lumabot-flow-template';
import { EModel } from './model';
export let ELumaBotFlowStatus;
(function (ELumaBotFlowStatus) {
  ELumaBotFlowStatus["Started"] = "started";
  ELumaBotFlowStatus["Completed"] = "completed";
})(ELumaBotFlowStatus || (ELumaBotFlowStatus = {}));
export const fieldsLumaBotFlow = _extends({}, fieldsIBaseModel, {
  accessedFrom: {
    type: 'Text'
  },
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  availabilities: {
    type: 'ID',
    ref: EModel.Availability,
    array: true
  },
  completedAt: {
    type: 'Date'
  },
  currentItemId: {
    type: 'Text'
  },
  facilities: {
    type: 'ID',
    ref: EModel.Facility,
    array: true
  },
  flowType: {
    type: 'Option',
    values: ELumaBotFlowType
  },
  language: {
    type: 'Option',
    values: ELanguage
  },
  lumabotFlowTemplate: {
    type: 'ID',
    ref: EModel.LumaBotFlowTemplate
  },
  lumabotFlowTemplateName: {
    type: 'Text'
  },
  nextLumaBotFlow: {
    type: 'ID',
    ref: EModel.LumaBotFlow
  },
  offer: {
    type: 'ID',
    ref: EModel.Offer
  },
  patient: {
    type: 'ID',
    ref: EModel.User
  },
  previousLumaBotFlow: {
    type: 'ID',
    ref: EModel.LumaBotFlow
  },
  questions: {
    type: 'Object',
    array: true
  },
  status: {
    type: 'Option',
    values: ELumaBotFlowStatus
  }
});